import { useContext } from "react";
import { Stack, Typography, Grid, Box } from "@mui/material";
// import moment from "moment";
//Import from project
import "../../Style/pagestyle.scss";
import LoginImage from "../../Assets/logoSystem.png";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import LoadingPage from "../../Utils/LoadingPage";
import EmptyData from "../Include/EmptyData/EmptyData";
import useGetScheduleForDashboard from "../../Hooks/useGetScheduleForDashboard";

export default function ScheduleByDay({ componentRef, day, courseId }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const { totalCount, tableData, loading } = useGetScheduleForDashboard({
    page: 1,
    limit: 100,
    day,
    courseId,
  });

  // console.log("tableData::", tableData);

  return (
    <div className="page-container">
      <Stack
        sx={{ padding: "20px" }}
        direction={"column"}
        spacing={1}
        ref={componentRef}
      >
        <Box>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <Stack direction="row" justifyContent={"left"}>
                <img alt="Logo" src={LoginImage} style={{ width: "120px" }} />
              </Stack>
            </Grid>
            <Grid item xs={4}>
              <Typography className="report-table-title">
                {t("student_statistic_by_class")}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {/* ================================ Table student and parents info ============================ */}
        <table className="report-table-container">
          <thead>
            <tr>
              <th style={{ width: "4%" }}>{t("no")}</th>
              <th style={{ width: "26%" }}>{t("thead_class")}</th>
              <th style={{ width: "25%" }}>{t("thead_teacher")}</th>
              <th style={{ width: "25%" }}>{t("thead_time")}</th>
              <th style={{ width: "10%" }}>{t("studying")}</th>
              <th style={{ width: "10%" }}>{t("complete")}</th>
            </tr>
          </thead>

          {loading ? (
            <tbody>
              <tr>
                <td colSpan={16}>
                  <LoadingPage />
                </td>
              </tr>
            </tbody>
          ) : (
            <>
              {tableData?.length === 0 || tableData === undefined ? (
                <tbody>
                  <tr>
                    <td colSpan={16}>
                      <EmptyData />
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {tableData?.map((item, index) =>
                    item?.times?.map((time, idx) => (
                      <tr key={`${item.classId._id}-${idx}`}>
                        {idx === 0 && (
                          <>
                            <td rowSpan={item.times.length} align="center">
                              {index + 1}
                            </td>
                            <td rowSpan={item.times.length}>
                              {item.classId.className +
                                " " +
                                item.classId.courseId.enName}
                            </td>
                            <td rowSpan={item.times.length}>
                              {item.teacherId.familyName}{" "}
                              {item.teacherId.userName}
                            </td>
                          </>
                        )}
                        <td align="center">
                          {time.startTime} - {time.endTime}
                        </td>
                        <td align="center">{time.totalStudying}</td>
                        <td align="center">{time.totalComplete}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              )}
            </>
          )}
        </table>
      </Stack>
    </div>
  );
}
